import React from "react";
import {
  BarChart2,
  Calendar,
  Copy,
  Eye,
  Inbox,
  Link,
  Linkedin,
  Mail,
  MessageCircle,
  RocketIcon,
  Route,
  Sliders,
  ThumbsUp,
  // User,
  UserCheck,
  UserPlus,
} from "lucide-react";

// import greenStars from "@/assets/svg/Stars_green.svg";
import CommonDropdownMenu from "../components/ui/DropDown/DropdownMenu";
import { StatusChip } from "../components/ui/Status/StatusChip";
import { formatCampaignScheduleSubtitle, getCampaignStatusMetaForTable } from "@/features/campaigns/utils/campaignScheduleDisplay";

export const CampaignStatusOptions = [
  { uid: "name", name: "Name" },
  { uid: "companySize", name: "Company Size" },
  { uid: "revenue", name: "Revenue" },
  { uid: "location", name: "Location" },
];

export const CampaignColumns = [
  {
    name: "Name",
    uid: "name",
    sortable: true,
    linkable: true,
    width: "300px",
  },
  {
    name: "Created on",
    uid: "created_on",
    sortable: true,
    linkable: true,
    align: "left",
  },
  { name: "Sent", uid: "sent", sortable: true, align: "center" },
  { name: "Clicked", uid: "clicked", sortable: true, align: "center" },
  { name: "Opened", uid: "opened", sortable: true, align: "center" },
  { name: "Status", uid: "status", sortable: true, align: "center" },
  {
    name: "Actions",
    uid: "actions",
    align: "center",
    sortable: false,
    width: "80px",
  },
];

export const CampaignTabs = [
  { key: "analytics", title: "Analytics", icon: <BarChart2 size={16} strokeWidth={3} /> },
  { key: "campaignsteps", title: "Campaign Steps", icon: <Route size={16} strokeWidth={2} /> },
  { key: "leads", title: "Leads", icon: <UserPlus size={16} strokeWidth={2} /> },
  { key: "individualsequences", title: "Individual Steps", icon: <Copy size={16} strokeWidth={2} /> },
  { key: "settings", title: "Settings", icon: <Sliders size={16} strokeWidth={2} /> },
];

export const ContactAnalysisColumns = [
  { uid: "name", name: "Name", sortable: true, align: "left", width: "180px" },
  { uid: "company", name: "Company", sortable: true, align: "left", width: "160px" },
  { uid: "engagementScore", name: "Engagement Score", sortable: true, align: "left", width: "160px" },
  {
    uid: "engagement_status",
    name: "Engagement Status",
    sortable: true,
    align: "center",
    width: "160px",
  },
];

export const ChannelViewTableColumns = [
  { uid: "full_name", name: "Name", sortable: true, align: "left", width: "180px" },
  { uid: "company", name: "Company", sortable: true, align: "left", width: "110px" },
  { uid: "designation", name: "Designation", sortable: true, align: "left", width: "160px" },
  { uid: "channel", name: "Channel", sortable: true, align: "center", width: "100px" },
  { uid: "step_order", name: "Step", sortable: true, align: "center" },
  { uid: "step_action", name: "Action", sortable: true, align: "center", width: "150px" },
  {
    uid: "engagement",
    name: "Sent/Opened/Clicked/Responded",
    sortable: true,
    align: "center",
    width: "220px",
  },
];

export const CampaignLeadsColumns = [
  { uid: "name", name: "Name", sortable: true, align: "left", width: "180px" },
  { uid: "company", name: "Company", sortable: true, align: "left", width: "120px" },
  { uid: "designation", name: "Position", sortable: true, align: "left", width: "160px" },
  { uid: "emailVerification", name: "Email", sortable: true, align: "left", width: "180px" },
  { uid: "current_step_order", name: "Current Step", sortable: true, align: "left", width: "120px" },
  {
    uid: "created_at",
    name: "Create/Modified",
    sortable: false,
    align: "left",
    width: "120px",
  },
  { uid: "engagementScore", name: "Engagement Score", sortable: true, align: "left", width: "140px" },
  {
    uid: "actions",
    name: "Actions",
    align: "center",
    sortable: false,
    width: "80px",
  },
];

export const CampaignConditions = [
  { id: 1, text: "Opened email", Icon: <Mail size={16} color="#207C97" /> },
  {
    id: 2,
    text: "Clicked on link in email",
    Icon: <Link size={16} color="#207C97" />,
  },
  {
    id: 3,
    text: "Booked a meeting",
    Icon: <Calendar size={16} color="#207C97" />,
  },
  {
    id: 4,
    text: "Accepted Linkedin Invite",
    Icon: <UserCheck size={16} color="#207C97" />,
  },
  {
    id: 5,
    text: "Opened Linkedin Message",
    Icon: <Linkedin size={16} color="#207C97" />,
  },
  {
    id: 6,
    text: "Viewed Linkedin Profile",
    Icon: <Eye size={16} color="#207C97" />,
  },
  {
    id: 7,
    text: "Like or Comment on Post",
    Icon: <ThumbsUp size={16} color="#207C97" />,
  },
];

export const CampaignSteps = [
  {
    id: 1,
    text: "Cold Email",
    Icon: <RocketIcon size={16} className="text-success-500" />,
    action: "email_send",
    channel: "email",
  },
  {
    id: 2,
    text: "Follow-up Email",
    Icon: <Inbox size={16} className="text-success-500" />,
    action: "followup_email",
    channel: "email",
  },
  {
    id: 4,
    text: "Send Connection Request",
    Icon: <UserPlus size={16} className="text-success-500" />,
    action: "linkedin_connect",
    channel: "linkedin",
  },
  {
    id: 5,
    text: "Send LinkedIn Message",
    Icon: <Linkedin size={16} className="text-success-500" />,
    action: "linkedin_sms",
    channel: "linkedin",
  },
  {
    id: 6,
    text: "Like Latest LinkedIn Post",
    Icon: <ThumbsUp size={16} className="text-success-500" />,
    action: "linkedin_like",
    channel: "linkedin",
  },
  // {
  //   id: 7,
  //   text: "View LinkedIn Profile",
  //   Icon: <Eye size={16} className="text-success-500" />,
  //   action: "view_profile",
  //   channel: "linkedin",
  // },
  {
    id: 7,
    text: "WhatsApp Message",
    Icon: <MessageCircle size={16} className="text-success-500" />,
    action: "whatsapp_sms",
    channel: "whatsapp",
  },
  // {
  //   id: 8,
  //   text: "Human Handover",
  //   Icon: <User size={16} className="text-success-500" />,
  //   action: "human_handover",
  // },
  // {
  //   id: 9,
  //   text: "AI Reply",
  //   secondaryText: "(with Human Fallback)",
  //   Icon: (
  //     <img src={greenStars} style={{ width: 16, height: 16 }} alt="AI Reply" />
  //   ),
  //   action: "ai_reply_with_human_fallback",
  // },
];

export const StepDropdownOptions = [
  { key: "urgency", label: "Urgency" },
  { key: "relevance", label: "Relevance" },
  { key: "intent", label: "Intent" },
];

export const campaignLanguageOptions = [
  { title: "English (India)", key: "English (India)" },
  { title: "English (UK)", key: "English (UK)" },
  { title: "English (US)", key: "English (US)" },
];

export const DEFAULT_SCHEDULE = [
  {
    id: 1,
    day: "Sunday",
    selected: false,
    timeFrom: "9:00 AM",
    timeTo: "9:00 AM",
  },
  {
    id: 2,
    day: "Monday",
    selected: true,
    timeFrom: "9:00 AM",
    timeTo: "5:00 PM",
  },
  {
    id: 3,
    day: "Tuesday",
    selected: true,
    timeFrom: "9:00 AM",
    timeTo: "5:00 PM",
  },
  {
    id: 4,
    day: "Wednesday",
    selected: true,
    timeFrom: "9:00 AM",
    timeTo: "5:00 PM",
  },
  {
    id: 5,
    day: "Thursday",
    selected: true,
    timeFrom: "9:00 AM",
    timeTo: "5:00 PM",
  },
  {
    id: 6,
    day: "Friday",
    selected: true,
    timeFrom: "9:00 AM",
    timeTo: "5:00 PM",
  },
  {
    id: 7,
    day: "Saturday",
    selected: true,
    timeFrom: "9:00 AM",
    timeTo: "5:00 PM",
  },
];

export const renderCampaignCell = (
  campaign,
  columnKey,
  actions,
) => {
  const cellValue = campaign[columnKey];
  switch (columnKey) {
    case "name":
      return (
        <p
          className="text-xs font-semibold text-gray-800 dark:text-gray-100 font-sans cursor-pointer text-wrap break-all break-words"
        >
          {cellValue}
        </p>
      );
    case "status": {
      const meta = getCampaignStatusMetaForTable(campaign);
      const scheduledUtc = campaign?.start_schedule?.scheduledForUtc;
      const isUpcoming = scheduledUtc && new Date(scheduledUtc).getTime() > Date.now();
      return (
        <StatusChip
          label={meta.label ?? cellValue}
          variant={meta.variant || "neutral"}
          tooltipContent={isUpcoming ? `Scheduled for ${formatCampaignScheduleSubtitle(campaign?.start_schedule)}` : undefined}
        />
      );
    }
    case "actions":
      return actions ? (
        <div className="flex items-center justify-center gap-2">
          <CommonDropdownMenu actions={actions} itemId={campaign.id} />
        </div>
      ) : null;
    default:
      return <p className="text-xs font-medium text-gray-500 dark:text-gray-400">{cellValue}</p>;
  }
};
